/**
 * Shared geometry between the SCREEN app and the PHONE zapper page.
 * The phone finds the on-screen QR with jsQR; its four corners in the camera
 * frame + this known rectangle in 800×600 game coordinates give the full
 * camera→game homography (the screen is flat, so one QR is enough).
 */
module.exports.LOBBY_QR_RECT = {x: 318, y: 148, w: 164, h: 164}; // the one join QR (lobby)

/**
 * Corner markers: FOUR tiny static QRs pinned to the screen corners
 * (content "dh:<corner>:<cols>x<rows>" — small payloads decode at small
 * sizes/distances, and they carry the live grid). Four spread anchors give
 * the phone its homography without depending on any single small code.
 */
module.exports.MARKERS = {
  tl: {x: 8, y: 8, s: 56},
  tr: {x: 736, y: 8, s: 56},
  br: {x: 736, y: 536, s: 56},
  bl: {x: 8, y: 536, s: 56}
};
// game-space anchor POINTS (the marker centres)
module.exports.ANCHOR_POINTS = {
  tl: {x: 36, y: 36},
  tr: {x: 764, y: 36},
  br: {x: 764, y: 564},
  bl: {x: 36, y: 564}
};
module.exports.GAME_W = 800;
module.exports.GAME_H = 600;
module.exports.GRID_H = 480;
